import { metricsBus, QueryType } from "@/common/buses";
import { useCallback } from "react";
import { SearchInitiator, useAnalyticsStore } from "@/common/store/analyticsStore";

export const useSendEvent = () => {
  const setSearchInitiator = useAnalyticsStore((state) => state.setSearchInitiator);
  const setSearchTag = useAnalyticsStore((state) => state.setSearchTag);

  const sendQuerySubmitted = useCallback((query: string[], queryType: QueryType, itemId?: string) => {
    const searchText = query.join(",");

    if (searchText) {
      setSearchInitiator(SearchInitiator.SearchInput);

      metricsBus.emit("searchQuerySubmitted", {
        query: searchText,
        queryType,
        queryCount: query.length,
        itemId
      });
    }

    setSearchTag(queryType === "Tag" && searchText ? searchText : null);
  }, []);

  return {
    sendQuerySubmitted,
  };
};
